export default "__VITE_ASSET__jPmIGMa0__"